import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import classNames from "classnames";
import FileExtensionPreview from "~/components/FileExtensionPreview";
import { useUploadingData } from "~/components/Upload/hooks/useUploadingData";
import { UPLOADING_FILE } from "~/constants/testIDs";
import { useHover } from "~/hooks/useHover";
/**
 * This component is used to display uploading file with upload progress and shimmer animation
 */ export const UploadingFileGalleryCard = (param)=>{
    let { upload, width, getClassName } = param;
    const { apiUploadData: { ext, size } } = upload;
    const { stateText } = useUploadingData(upload);
    const { handleHover, handleUnhover, isHovering } = useHover();
    const title = upload.file.name;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": UPLOADING_FILE,
        "data-asset-title": title,
        onMouseEnter: handleHover,
        onMouseMove: handleHover,
        onMouseLeave: handleUnhover,
        className: "relative flex h-full flex-col",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames("absolute inset-[-6px] cursor-default rounded border-2 border-transparent", isHovering && "bg-pigeon-50", getClassName === null || getClassName === void 0 ? void 0 : getClassName({
                    isHovering
                }))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "relative flex grow flex-col rounded border border-pigeon-100 bg-white p-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex grow",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "flex size-8 shrink-0 items-center justify-center rounded bg-pigeon-100",
                            children: /*#__PURE__*/ _jsx(FileExtensionPreview, {
                                ext: ext,
                                color: "gray"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "relative",
                        children: [
                            !!size && /*#__PURE__*/ _jsx(Tooltip, {
                                label: title,
                                side: "top",
                                sideOffset: 4,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "pointer-events-auto truncate text-left font-medium text-pigeon-700 hover:underline",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                style: {
                                    width
                                },
                                className: "truncate text-12 text-pigeon-400",
                                children: stateText
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
